import React, { useEffect, useState } from 'react';
import { Box, Button } from '@mui/material';
import VinImeiLogs from '../VinKycLogs/VinImeiLogs';
import KycLogs from '../VinKycLogs/KycLogs';

const VinKycLogsPage = () => {
  const [activeTab, setActiveTab] = useState<"vinimei" | "kyc">("vinimei");

  return (
    <Box sx={{ width: "100%" }}>
      {/* Tab Navigation */}
      <Box sx={{ display: "flex", borderBottom: "2px solid #eee", mb: 2 }}>
        <Button
          onClick={() => setActiveTab("vinimei")}
          sx={{
            fontWeight: "bold",
            fontSize: "1.1rem",
            color: activeTab === "vinimei" ? "#E60012" : "#888",
            borderBottom:
              activeTab === "vinimei"
                ? "3px solid #E60012"
                : "3px solid transparent",
            borderRadius: 0,
            background: "none",
            boxShadow: "none",
            px: 3,
            py: 2,
            textTransform: "none",
          }}
        >
          VIN IMEI LOGS
        </Button>
        <Button
          onClick={() => setActiveTab("kyc")}
          sx={{
            fontWeight: "bold",
            fontSize: "1.1rem",
            color: activeTab === "kyc" ? "#E60012" : "#888",
            borderBottom:
              activeTab === "kyc"
                ? "3px solid #E60012"
                : "3px solid transparent",
            borderRadius: 0,
            background: "none",
            boxShadow: "none",
            px: 3,
            py: 2,
            textTransform: "none",
          }}
        >
          KYC LOGS
        </Button>
      </Box>

      {/* Conditional rendering of tables */}
      {activeTab === "vinimei" && <VinImeiLogs />}
      {activeTab === "kyc" && <KycLogs />}
    </Box>
  );
};

export default VinKycLogsPage;